export enum GlobalSearchAppName {
  CLAIMS_APP = 'claims',
  DISPUTES_APP = 'disputes',
  INVOICE_APP = 'invoicing-workbench',
  SHIPMENTS_APP = 'disputes',
  PND_APP = 'pnd',
}
